import { render, staticRenderFns } from "./Dunes.vue?vue&type=template&id=50cf5fa4&scoped=true&"
import script from "./Dunes.vue?vue&type=script&lang=js&"
export * from "./Dunes.vue?vue&type=script&lang=js&"
import style0 from "./Dunes.vue?vue&type=style&index=0&id=50cf5fa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf5fa4",
  null
  
)

export default component.exports